export const toEmptyStringIfNull = (str) => str === null ? "" : str;
